<template>
  <div>
    <b-alert variant="primary" show v-if="!isFormShow && !isUser">There'n no user for this employee, <a href="" @click.prevent="showFormCreateEmployee()">Click here to create one.</a></b-alert>
    <b-card class="no-border animated" v-show="isFormShow">
      <b-form v-on:submit.prevent="onSubmit">
        <legend>{{ isEdit ? 'Edit Employee User' : 'Create Employee User'}}</legend>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="input_username">Username</label>
            <input type="text"
              class="form-control"
              id="input_username"
              placeholder="Username"
              :class="{'is-valid': is_valid_username, 'is-invalid': !is_valid_username}"
              v-model.trim="form.username"
              @keyup="onChangeUsername"
              :disabled="isDisabled"
              required>
            <b-form-feedback>Username must only contains alphanumeric and underscores (3 - 30 chars)</b-form-feedback>
            <small v-if="userExist"><font color="#f86c6b">Username already exists</font></small>
          </div>
          <div class="form-group col-md-6">
            <label for="input_email">Email</label>
            <input type="email"
              class="form-control"
              id="input_email"
              v-model.trim="form.email"
              placeholder="Email"
              required>
            <b-form-feedback>Please provide a valid email address</b-form-feedback>
          </div>
        </div>
        <legend v-show="!isDisabled">Password</legend>
        <div class="form-row" v-show="!isDisabled">
          <div class="form-group col-md-6">
            <label for="input_password">Password</label>
            <input
              type="password"
              v-model.lazy="form.password"
              class="form-control"
              :class="{'is-valid': valid.password, 'is-invalid': invalid.password}"
              id="input_password"
              placeholder="Password">
            <div class="invalid-feedback" v-if="invalid.password">{{feedback.password}}</div>
          </div>
          <div class="form-group col-md-6">
            <label for="input_password2">Password confirmation</label>
            <input
              type="password"
              v-model.lazy="form.password2"
              :class="{'is-valid': valid.password2, 'is-invalid': invalid.password2}"
              class="form-control"
              id="input_password2"
              placeholder="Password confirmation">
            <div class="invalid-feedback" v-if="invalid.password2">{{feedback.password2}}</div>
          </div>
        </div>
        <legend>Address</legend>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="input_address_country">Country</label>
            <input type="text"
              v-model="form.address.country"
              class="form-control"
              id="input_address_country"
              placeholder="Country">
          </div>
          <div class="form-group col-md-6">
            <label for="input_address_state">State</label>
            <input type="text"
              v-model="form.address.state"
              class="form-control"
              id="input_address_state"
              placeholder="State">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="input_address_city">City</label>
            <input type="text"
              v-model="form.address.city"
              class="form-control"
              id="input_address_city"
              placeholder="City">
          </div>
          <div class="form-group col-md-6">
            <label for="input_address_zip_code">Zip / Postal Code</label>
            <input type="text"
              v-model="form.address.zip_code"
              class="form-control"
              id="input_address_zip_code"
              placeholder="Zip / Postal Code">
          </div>
        </div>
        <b-form-group id="label_address_address1"
          label="Address 1"
          label-for="input_address_address1">
          <b-form-input id="input_address_address1"
            type="text"
            v-model="form.address.address1"
            placeholder="Address line 1">
          </b-form-input>
        </b-form-group>
        <b-form-group id="label_address_address2"
          label="Address 2"
          label-for="input_address_address2">
          <b-form-input id="input_address_address2"
            type="text"
            v-model="form.address.address2"
            placeholder="Address line 2">
          </b-form-input>
        </b-form-group>
        <hr>
        <b-button type="submit" variant="primary">Save changes</b-button>
        <b-button class="pull-right" variant="outline-secondary" @click="cancelAction()">Cancel</b-button>
      </b-form>
    </b-card>
    <b-card v-show="isUser">
      <div slot="header">
        User Information of <strong>{{displayName}}</strong>
      </div>
      <div class="child-padding">
        <div>Name : {{userEmployee.full_name}}</div>
        <div>Username : {{userEmployee.username}}</div>
        <div>Email : {{userEmployee.email}}</div>
        <div>Member Since :  {{userEmployee.created_at}}</div>
      </div>
      <div class="pull-right" v-show="isTransporter">
        <b-button variant="primary" @click="editUserEmployee()">Edit</b-button>
        <b-button v-b-modal.remove_user_employee variant="danger">Remove</b-button>
      </div>
    </b-card>
     <b-modal
        id="remove_user_employee"
        title="Remove User Employee"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="removeUser()">
        <p class="my-4">Are you sure do you want to remove this user employee ?</p>
     </b-modal>
  </div>
</template>
<script>
import CardListInfo from '@/components/CardListInfo';
import { get, isEmpty } from 'lodash';

export default {
  components: {
    CardListInfo,
  },
  name: 'user_employee_detail',
  data() {
    return {
      form: {
        id: '',
        employee_id: null,
        full_name: '',
        username: '',
        email: '',
        type: '',
        password: '',
        password2: '',
        company: '',
        address: {
          country: '',
          state: '',
          city: '',
          zip_code: '',
          address1: '',
          address2: '',
        },
      },
      userExist: false,
      checkTimeout: null,
      valid: {
        password: false,
        password2: false,
      },
      invalid: {
        password: false,
        password2: false,
      },
      feedback: {
        password: '',
        password2: '',
      },
      isFormShow: false,
      isUser: false,
      isEdit: false,
    };
  },
  created() {
    const { employeeId } = this.$route.params;
    this.$store.dispatch('employees/LOAD_DETAIL_DATA');
    this.$store.commit('employees/SET_DETAIL_ID', employeeId);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['employees/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.name;
    },
    is_valid_username() {
      return this.form.username.match(/^\w{3,30}$/);
    },
    userEmployee() {
      return this.detailedInfo.user || '';
    },
    isDisabled() {
      return this.userEmployee.username && true;
    },
    users() {
      return this.$store.getters['users/users'];
    },
    companyData() {
      return this.detailedInfo.company || '';
    },
    isTransporter() {
      return this.companyData.type !== 'TRANSPORTER';
    },
  },
  watch: {
    detailedInfo(data) {
      let show = false;
      const {
        id, name, company, user,
      } = data;
      this.form.employee_id = id;
      this.form.company = company;
      this.form.full_name = name;
      this.form.type = 'DEFAULT';
      if (user) {
        show = true;
      }
      this.isUser = show;
    },
  },
  methods: {
    get(object, key) {
      return get(object, key) || '';
    },
    showFormCreateEmployee() {
      this.isFormShow = true;
    },
    editUserEmployee() {
      this.isUser = false;
      this.isFormShow = true;
      this.isEdit = true;
      this.form = { ...this.userEmployee };

      if (isEmpty(this.form.address)) {
        this.form.address = {
          country: '',
          state: '',
          city: '',
          zip_code: '',
          address1: '',
          address2: '',
        };
      }
    },
    onChangeUsername() {
      clearTimeout(this.checkTimeout);
      this.checkTimeout = setTimeout(async () => {
        await this.$store.commit('users/CLEAR_QUERY');
        await this.$store.commit('users/SET_QUERY_SEARCH', this.form.username);
        await this.$store.dispatch('users/FIND_DATA');

        let userExist = false;
        const users = await this.users;

        for (let i = 0; i < users.length; i++) {
          if (users[i].username.toLowerCase() === this.form.username) {
            userExist = true;
            break;
          }
        }

        this.userExist = userExist;
      }, 3e2);
    },
    onSubmit() {
      if (this.validate()) {
        const { employeeId } = this.$route.params;
        const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';
        this.$store.commit('users/SET_DETAIL_ID', this.form.id);

        this.$store.dispatch(`users/${action}`, this.form).then((user) => {
          if (user && !this.isEdit) {
            this.$store.dispatch('employees/CREATE_EMPLOYEE_USER', user.id).then(() => {
              this.$router.push({ name: 'Employee Preview', params: { employeeId, section: '' } });
            });
          } else {
            this.cancelAction();
            this.detailedInfo.user = user;
            this.$router.push(`/admin/employees/${employeeId}/user`);
          }
        });
      }
    },
    validate() {
      const passOk = this.checkPassword();
      if (!passOk || this.userExist) return false;
      return true;
    },
    checkPassword() {
      const { password, password2 } = this.form;
      if (password || password2) {
        if (password !== password2) {
          this.feedback.password2 = 'Passwords does not match!';
          this.valid.password2 = false;
          this.invalid.password2 = true;
          return false;
        }
      }
      return true;
    },
    cancelAction() {
      this.isFormShow = false;
      this.isEdit = false;
      this.isUser = this.userEmployee ? !this.isFormShow : false;
    },
    removeUser() {
      const { employeeId } = this.$route.params;
      const { id } = this.userEmployee;

      this.$store.dispatch('employees/DELETE_EMPLOYEE_USER').then((deleted) => {
        if (deleted) {
          this.$store.dispatch('users/DELETE_DATA', id).then((ok) => {
            if (ok) {
              this.$router.push({ name: 'Employee Preview', params: { employeeId, section: '' } });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="sass">
  .child-padding > div
    padding: 5px
</style>




// WEBPACK FOOTER //
// src/views/pages/admin/employees/detail/User.vue